export const LOGIN_NO_ACCOUNT_FOUND = 'LOGIN_NO_ACCOUNT_FOUND'
export const LOGIN_ACCOUNT_EXISTS = 'LOGIN_ACCOUNT_EXISTS'
export const LOGIN_ACCOUNT_EXISTS_WITHOUT_NAME = 'LOGIN_ACCOUNT_EXISTS_WITHOUT_NAME'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const RESET_LOGIN_DATA = 'RESET_LOGIN_DATA'
export const LOGIN_ACCOUNT_WITH_EMPTY_TNC = 'LOGIN_ACCOUNT_WITH_EMPTY_TNC'
export const LOGIN_ACCOUNT_SUSPENDED = 'LOGIN_ACCOUNT_SUSPENDED'
